import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'semantic-ui-react';
import CenterPanel from './centerPanel';
import PageHeader from '../../header';
import NotFoundPage from '../../../../containers/NotFoundPage';
import { getWaitingAreas, updateWaitingAreasSearch } from '../../../../actions/waitingArea';
import { updateSearchColumn } from 'actions/shared';
import { updateFilterValue } from 'actions/organisation';
import { Media } from '../../../../mediaSetting';

let getWaitingAreaForAdminUser = (waitingAreas, userProfile) => {
  if (
    userProfile &&
    userProfile.hasEntityAdminRights &&
    userProfile.hasEntityAdminRights.isOrgAdmin &&
    userProfile.shouldLoadDirectlyAssociatedWAs
  ) {
    const waitingAreaDA = userProfile.waitingAreasDirectlyAssociated.map((wa) => wa.id);
    return waitingAreas.filter((wa) => waitingAreaDA.indexOf(wa.id) > -1);
  }

  return waitingAreas;
};

export default function ViewAllWaitingArea(props) {
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  const waitingAreasFromRedux = useSelector((state) => state.waitingAreaReducer.waitingAreas);
  const fetchingWaitingAreasFromRedux = useSelector((state) => state.waitingAreaReducer.fetchingWaitingAreas);
  const currentWaitingAreasFilterFromRedux = useSelector((state) => state.waitingAreaReducer.currentWaitingAreasFilter);

  const dispatch = useDispatch();
  const [waitingAreasFiltered, setWaitingAreasFiltered] = useState(waitingAreasFromRedux || []);
  const [waitingAreasGray, setWaitingAreasGray] = useState([]);
  const [noHeader, setNoHeader] = useState(props.noHeader || false);
  const [waitingAreas, setWaitingAreas] = useState();
  const [fetchingWaitingAreas, setFetchingWaitingAreas] = useState();
  const [meetingRoomSortToggle, setMeetingRoomSortToggle] = useState();

  const updateSearch = () => {
    let dontSetState = true;
    let resultOffilterTwo = waitingAreaFilterSearch(
      getWaitingAreaForAdminUser(waitingAreasFromRedux, userProfile),
      dontSetState,
      currentWaitingAreasFilterFromRedux,
      props.updateSearchColumn
    );
    let filteredAndGrayMeetingRooms = {
      waitingAreasGray: resultOffilterTwo.waitingAreasGray || [],
      waitingAreasFiltered: resultOffilterTwo.waitingAreasFiltered || [],
    };
    setWaitingAreasFiltered(filteredAndGrayMeetingRooms.waitingAreasFiltered);
    setWaitingAreas(getWaitingAreaForAdminUser(waitingAreasFromRedux, userProfile));
    setWaitingAreasGray(filteredAndGrayMeetingRooms.waitingAreasGray);
    setFetchingWaitingAreas(fetchingWaitingAreasFromRedux);
  };

  useEffect(() => {
    dispatch(updateFilterValue(1));
    if (fetchingWaitingAreasFromRedux != true && !props.waitingAreasInitiallyLoaded) {
      dispatch(getWaitingAreas());
    }
    updateSearch();

    return () => {
      dispatch(updateWaitingAreasSearch(''));
      dispatch(updateSearchColumn(null));
    };
  }, []);

  // this useEffect trigger the search Method on this props
  useEffect(() => {
    updateSearch();
  }, [currentWaitingAreasFilterFromRedux, fetchingWaitingAreasFromRedux, waitingAreasFromRedux]);

  const toggleWaitingArea = (toWhat, type) => {
    doSorting(toWhat, type);
    setMeetingRoomSortToggle(!meetingRoomSortToggle);
  };

  const waitingAreaFilterSearch = (waitingAreas, dontSetState, currentFilter, searchColumn) => {
    let waitingAreasToFilter = waitingAreas && waitingAreas.length ? waitingAreas : waitingAreasFromRedux;
    let smartQuery = null;
    if (currentFilter.indexOf('¤') > -1) {
      let splitted = currentFilter.split('¤');
      smartQuery = (object) => {
        if (object[splitted[0]]) {
          if (object[splitted[0]].toLowerCase() == splitted[1].toLowerCase()) {
            return true;
          } else return false;
        } else {
          return false;
        }
      };
    }
    let containsSearchExpression = (waitingArea) => {
      let searchText =
        waitingArea.name.toLowerCase() +
        ' ' +
        waitingArea.organisationAbbreviatedName.toLowerCase() +
        waitingArea.organisationName.toLowerCase();

      return searchText.indexOf(currentFilter.toLowerCase()) > -1;
    };

    // If searchColumn is not null, filter the result by searchColumn;
    // Otherwise, do normal search
    let filtered =
      searchColumn != null
        ? waitingAreasToFilter.filter((waitingArea) => {
            return waitingArea[searchColumn].toLowerCase() == currentFilter.toLowerCase();
          })
        : waitingAreasToFilter.filter(smartQuery || containsSearchExpression);

    let differenceBetweenArrays = waitingAreasToFilter.filter(function (obj) {
      return !filtered.some(function (obj2) {
        return obj.name == obj2.name;
      });
    });

    if (!dontSetState) {
      setWaitingAreasGray(differenceBetweenArrays);
      setWaitingAreasFiltered(filtered);
    } else {
      return {
        waitingAreasGray: differenceBetweenArrays,
        waitingAreasFiltered: filtered,
      };
    }
  };

  const doSorting = (typeofSorting) => {
    let filterFunction = '';
    if (typeofSorting == 'descending') {
      filterFunction = function (a, b) {
        return a.name > b.name;
      };
    } else if (typeofSorting == 'ascending') {
      filterFunction = function (a, b) {
        return a.name < b.name;
      };
    }
    let sorted = waitingAreasFromRedux.sort(filterFunction);
    setWaitingAreasFiltered(sorted);
  };

  let header = '';

  if (!noHeader) {
    header = (
      <span>
        <PageHeader title={APP.LANGUAGE.ViewWaitingArea.Title} titleColor="color-waiting-area-text">
          <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.WaitingAreaIcon.default} />
        </PageHeader>
      </span>
    );
  }

  if (!props.isInQuicKView && waitingAreasFromRedux.length === 0 && !fetchingWaitingAreasFromRedux) {
    return <NotFoundPage dispatch={dispatch} />;
  }
  return (
    <div>
      {header}
      <div
        className="main-ui-container waiting-area-view-all new-waiting-area-view-all"
        data-rendered-as-container={noHeader}
      >
        <Container fluid as={Media} greaterThanOrEqual="computer" className="view-all-waiting-area-container">
          <CenterPanel
            loggedInUserHandler={props.loggedInUserHandler}
            noHeader={noHeader}
            doSorting={doSorting}
            waitingAreasGray={waitingAreasGray}
            waitingAreasFiltered={waitingAreasFiltered}
            currentWaitingAreasFilter={currentWaitingAreasFilterFromRedux}
            updateSearchColumn={props.updateSearchColumn}
          />
        </Container>
        <Container fluid as={Media} lessThan="computer" className="view-all-waiting-area-container">
          <CenterPanel
            loggedInUserHandler={props.loggedInUserHandler}
            noHeader={noHeader}
            doSorting={doSorting}
            waitingAreasGray={waitingAreasGray}
            waitingAreasFiltered={waitingAreasFiltered}
            currentWaitingAreasFilter={currentWaitingAreasFilterFromRedux}
            updateSearchColumn={props.updateSearchColumn}
            isOnMobileOrTablet={true}
            isInQuicKView={props.isInQuicKView}
          />
        </Container>
      </div>
    </div>
  );
}
